const dummyResponse = [
  {
    imgurl: '/image/listBook/1.png',
    title: 'The Subtle Art Not Giving a F*ck',
    writer: 'Mark Watson',
    price: 100000,
    discount_price: 10,
  },
  {
    imgurl: '/image/listBook/2.png',
    title: 'Start With Why',
    writer: 'Simon Sinek',
    price: 221000,
    discount_price: 10,
  },
  {
    imgurl: '/image/listBook/3.png',
    title: 'The Design Every day',
    writer: 'Mark Watson',
    price: 221000,
    discount_price: 10,
  },
  {
    imgurl: '/image/listBook/ikigai.png',
    title: 'Steal like artist jurnal',
    writer: 'Austin Kleon',
    price: 142000,
    discount_price: 10,
  },
  {
    imgurl: '/image/listBook/download.png',
    title: 'Steal like artist jurnal',
    writer: 'Austin Kleon',
    price: 142000,
    discount_price: 10,
  },
];
export default dummyResponse;
